<template>
  <button
    v-on="$listeners"
    v-bind="$attrs"
    class="app-button"
    :class="[variationClass, rippleClass, invertedClass]"
    data-jest="app-button"
  >
    <slot>Enviar</slot>
  </button>
</template>

<script>
export default {
  name: 'AppButton',
  props: {
    variation: {
      type: String,
      default: 'primary',
    },

    inverted: {
      type: Boolean,
      default: false,
    },

    ripple: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    variationClass() {
      return `app-button--${this.variation}`
    },

    rippleClass() {
      return this.ripple ? 'ripple' : ''
    },

    invertedClass() {
      return this.inverted && 'inverted'
    },
  },
}
</script>

<style scoped>
/* Ripple effect secondary */
/* .app-button--primary.ripple {
  --r-hover-bg: var(--c-secondary);
  --r-active-bg: var(--c-secondary-500);
}

.app-button--secondary.ripple {
  --r-hover-bg: var(--c-primary);
  --r-active-bg: var(--rgba-primary-400);
} */

/* MAGENTA */
.app-button.app-button--magenta {
  color: #fff;
  border: none;
  background-color: var(--c-magenta-500);
}

.app-button.app-button--magenta.inverted {
  color: var(--c-magenta-500);
  border: 1px solid var(--c-magenta-500);
  background-color: #fff;
}

.app-button--magenta:not(:disabled):hover {
  background-color: var(--c-magenta-800);
}

.app-button--magenta.inverted:hover {
  color: #fff;
  border-color: transparent;
  background-color: var(--c-magenta-500);
}

/* Ripple effect
.app-button--magenta.ripple {
  --r-hover-bg: var(--c-magenta-500);
  --r-active-bg: var(--c-magenta-300);
  --r-transition: all 0.6s;
}

/* Ripple effect inverted */
/* .app-button--magenta.ripple.inverted {
  --r-hover-bg: var(--c-magenta-300);
  --r-active-bg: var(--c-magenta-300);
} */

/* Ripple */
.ripple {
  position: relative;
  overflow: hidden;
  outline: 0;
}

.ripple:before {
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.6);
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
}

.ripple:focus:before {
  transition: all 0.5s ease-out;
  opacity: 0;
  width: 160px;
  height: 160px;
  margin-top: -80px;
  margin-left: -80px;
}
</style>
